import { render, staticRenderFns } from "./InitiateReview.vue?vue&type=template&id=6daacefb&scoped=true"
import script from "./InitiateReview.vue?vue&type=script&lang=js"
export * from "./InitiateReview.vue?vue&type=script&lang=js"
import style0 from "./InitiateReview.vue?vue&type=style&index=0&id=6daacefb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daacefb",
  null
  
)

export default component.exports